import { lazy } from "@loadable/component";
import withAemIntegration from "../../withAemIntegration";

const MediaComponent = lazy(() =>
    import("@lexus.com/ui/dist/components/MediaComponent")
);

const ComponentEditConfig = {
    emptyLabel: "Media Module",
    isEmpty: function (props) {
        return !props || !props.title || props.title.trim().length < 1;
    },
};

const transformData = (props) => {
    const transformed = { ...props.media || {} };
    return transformed;
};

const Media = (props) => {
    const data = transformData(props);
    return <MediaComponent {...data} />;
};

export default withAemIntegration("lexus/components/content/media")(
    Media,
    ComponentEditConfig
);
